import { z } from 'zod';

export const newUserSchema = z
  .object({
    accountType: z.enum(['COLLABORATOR', 'CLIENT']),
    name: z.string().trim().min(1, 'O nome é obrigatório'),
    email: z.string().trim().min(1, 'O e-mail é obrigatório').email('E-mail inválido'),
    whatsapp: z.string().optional(),
    role: z.string().optional(),
    partnerIds: z.array(z.string()),
    allPartners: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (data.accountType === 'COLLABORATOR' && !data.role) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['role'],
        message: 'Selecione um perfil',
      });
    }

    const hasBrands = data.allPartners || data.partnerIds.length > 0;
    if (!hasBrands) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['partnerIds'],
        message:
          data.accountType === 'COLLABORATOR'
            ? 'Selecione uma ou mais marcas'
            : 'Selecione uma marca',
      });
    }

    if (data.accountType === 'CLIENT' && data.partnerIds.length !== 1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['partnerIds'],
        message: 'Selecione uma marca',
      });
    }
  });

export type NewUserFormValues = z.infer<typeof newUserSchema>;

export const COLLABORATOR_TYPE_HINT =
  'Membros da equipe interna que podem ter acesso administrativo, criação ou visualização de reports.';

export const CLIENT_TYPE_HINT =
  'Representantes de marca e clientes com acesso de visualização de reports.';

export const CREATE_USER_ERROR_TOAST = {
  title: 'Não foi possível cadastrar o usuário.',
  description: 'Entre em contato com o suporte pelo e-mail: suporte@culturemonitor.com',
};

export const formatWhatsappPayload = (value?: string): string | undefined => {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;
  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return undefined;
  if (digits.startsWith('55')) return `+${digits}`;
  return `+55${digits}`;
};
